import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ForbiddenPage } from '@/components/account/forbidden-page/forbidden-page';

// Only mounted when a workspace guard explicitly redirects here.
function ForbiddenRoute() {
  const navigate = useNavigate();
  return <ForbiddenPage onAction={() => void navigate({ to: '/dashboard' })} />;
}

export const Route = createFileRoute('/_app/forbidden')({
  component: ForbiddenRoute,
});
